module.exports = __webpack_public_path__ + "static/media/image5.c45c1bd9.png";